import $ from 'jquery';
import React, { useEffect } from 'react';
import ProductSlider from './ProductSlider';

const Shop1 = () => {
    useEffect(() => {
        $('.single_tab_button_group > li > a').eq(0).addClass("selected");
        $('.single_tab_container > .single_tab_info').eq(0).css({ 'display': 'block' });
        $('.single_tab_button_group').on("click", function (e) {
            if ($(e.target).is("a")) {

                /*Handle Tab Nav*/
                $('.single_tab_button_group > li > a').removeClass("selected");
                $(e.target).addClass("selected");

                /*Handles Tab Content*/
                var clicked_index = $("a", this).index(e.target);
                $('.single_tab_container > .single_tab_info').css({ 'display': 'none' });
                $('.single_tab_container > .single_tab_info').eq(clicked_index).fadeIn();

            }
            $(this).blur();
            return false;
        });

        // Product Zoom
        $('.product_zoom_button_group > li > a').eq(0).addClass("selected");
        $('.product_zoom_container > .product_zoom_info').eq(0).css({ 'display': 'block' });
        $('.product_zoom_button_group').on("click", function (e) {
            if ($(e.target).is("a")) {

                /*Handle Tab Nav*/
                $('.product_zoom_button_group > li > a').removeClass("selected");
                $(e.target).addClass("selected");

                /*Handles Tab Content*/
                var clicked_index = $("a", this).index(e.target);
                $('.product_zoom_container > .product_zoom_info').css({ 'display': 'none' });
                $('.product_zoom_container > .product_zoom_info').eq(clicked_index).fadeIn();
            }
            $(this).blur();
            return false;
        });

        //Single Product Price Calculate
        function CalcPrice(qty) {
            var price = $(".product_per_price").attr("data-content");
            var total = parseFloat((price * qty)).toFixed(2);
            $(".product_total_price").text(total);
        }
        $(document).on("click", ".product_quantity_subtract", function (e) {
            var value = $("#product_quantity_input").val();
            var newValue = parseInt(value) - 1;
            if (newValue < 0) newValue = 0;
            $("#product_quantity_input").val(newValue);
            CalcPrice(newValue);
        });
        $(document).on("click", ".product_quantity_add", function (e) {
            var value = $("#product_quantity_input").val();
            var newValue = parseInt(value) + 1;
            $("#product_quantity_input").val(newValue);
            CalcPrice(newValue);
        });
        $(document).on("blur", "#product_quantity_input", function (e) {
            var value = $("#product_quantity_input").val();
            CalcPrice(value);
        });



    }, []);
    return (
        <div className="main-wrapper">
            <div className="product_view">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="product_left">
                                <div className="product_zoom">
                                    <div className="product_zoom_container">
                                        <div className="product_zoom_info selected">
                                            <div className="product_image_zoom">
                                                <img src="images/single/1.jpg" alt="img" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="product_right">
                                <div className="product_info">
                                    <div className="product_title"><h4>Cocoa Brownies</h4></div>
                                    <div className="product_rating">
                                        <i className="ion-ios-star"></i>
                                        <i className="ion-ios-star"></i>
                                        <i className="ion-ios-star"></i>
                                        <i className="ion-ios-star"></i>
                                        <i className="ion-ios-star"></i>
                                        <div className="product_rating_details">(2 Customer Reviews)</div>
                                    </div>
                                </div>
                                <div className="product_price">
                                    <del>$105.00</del> <span className="product_per_price" data-content="95.00"></span> $<span className="product_total_price">95.00</span>
                                </div>
                                <div className="product_description">Lorem ipsum dolor sit amet, consectetur adipiscing elittempor incididunt ut labore et
                                    dolore magna aliqua. Ut enad minim veniam, quis nostrud exercitation ullamco lab
                                    aliquip ex ea commodo consequat penat.
                                </div>
                                <div className="product_view_bottom">
                                    <div className="product_quantity">
                                        <div className="product_quantity_inner">
                                            <span className="product_quantity_subtract">
                                                <i className="ion-ios-minus-empty"></i>
                                            </span>
                                            <input type="text" id="product_quantity_input" placeholder="0" value="1" />
                                            <span className="product_quantity_add">
                                                <i className="ion-ios-plus-empty"></i>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="button_group">
                                        <a className="button" href="#">Add to Cart</a>
                                    </div>
                                </div>

                                <div className="product_meta">
                                    <ul>
                                        <li><span>SKU:</span> 012</li>
                                        <li><span>Category:</span> Dessert</li>
                                        <li><span>Tag:</span> Cake, Chocolate, Baking</li>
                                    </ul>
                                </div>
                                <div className="post_share">
                                    <ul className="share_list">
                                        <li>Share:</li>
                                        <li><a href="#"><i className="ion-social-facebook"></i></a></li>
                                        <li><a href="#"><i className="ion-social-twitter"></i></a></li>
                                        <li><a href="#"><i className="ion-social-dribbble-outline"></i></a></li>
                                        <li><a href="#"><i className="ion-social-instagram-outline"></i></a></li>
                                        <li><a href="#"><i className="ion-social-pinterest-outline"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="single_tab section_sm">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <ul className="single_tab_button_group">
                                <li className="single_tab_button selected">
                                    <a className="selected">Description</a>
                                </li>
                                <li className="single_tab_button">
                                    <a>Recipe Description</a>
                                </li>
                                <li className="single_tab_button">
                                    <a>Reviews (10)</a>
                                </li>
                            </ul>

                            <div className="single_tab_container">
                                <div className="single_tab_info selected">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit tempor incididunt ut labore et.ad minim veniam, quis nostrud exercitation
                                        ullamcoab Lorem ipsum dolor sit amet, consectetur adipiscingincididunt ut labore et dolore magna aliqua. Ut enad minim
                                        veniam, quis nostrud exercitation ullamco labaliquip ex ea commodo consequat. Penat.aliquip ex ea commodo .
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit tempor incididunt.</p>
                                </div>

                                <div className="single_tab_info">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit tempor incididunt ut labore et.ad minim veniam, quis nostrud exercitation
                                        ullamcoab Lorem ipsum dolor sit amet, consectetur adipiscingincididunt ut labore et dolore magna aliqua. Ut enad minim
                                        veniam, quis nostrud exercitation ullamco labaliquip ex ea commodo consequat. Penat.aliquip ex ea commodo .
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit tempor incididunt.</p>
                                </div>

                                <div className="single_tab_info">
                                    <div className="review_sec">
                                        <h6 className="review_title">1 review for <a>Product Name</a></h6>
                                        <ul className="review_area">

                                            <li className="blog_review_user">
                                                <div className="reviewer_div">
                                                    <div className="reviewer">
                                                        <img alt="img" src="images/blog/commenter1.png" className="avatar" />
                                                    </div>
                                                    <div className="review_block">
                                                        <div className="product_rating">
                                                            <i className="ion-android-star"></i>
                                                            <i className="ion-android-star"></i>
                                                            <i className="ion-android-star"></i>
                                                            <i className="ion-android-star"></i>
                                                            <i className="ion-android-star-half"></i>
                                                        </div>
                                                        <h4 className="reviewer_name">Elezabeth Doe <span className="review_date">07/08/2022</span></h4>
                                                        <p className="reviewer_review">Senectus et netus et malesuada. Nunc pulvinar sapien et ligula ullamcorper malesuada proin. Neque convallis a cras
                                                            semper auctor. Libero id faucibus nisl tincidunt eget. </p>

                                                    </div>
                                                </div>
                                            </li>


                                            <li className="blog_review_user">
                                                <div className="reviewer_div">
                                                    <div className="reviewer">
                                                        <img alt="img" src="images/blog/commenter2.png" className="avatar" />
                                                    </div>
                                                    <div className="review_block">
                                                        <div className="product_rating">
                                                            <i className="ion-android-star"></i>
                                                            <i className="ion-android-star"></i>
                                                            <i className="ion-android-star"></i>
                                                            <i className="ion-android-star-half"></i>
                                                            <i className="ion-android-star-outline"></i>
                                                        </div>
                                                        <h4 className="reviewer_name">Jennifer Page <span className="review_date">29/07/2022</span></h4>
                                                        <p className="reviewer_review">As the world continues to fight COVID-19 some property owners are searching for way they can improve the security of their buildings.</p>

                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="reviews-pagination">
                                            <span aria-current="page" className="page-numbers current">1</span>
                                            <a className="page-numbers">2</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="related_products">
                <div className="container">
                    <div className="section_header">
                        <h2 className="section_title">Related Products</h2>
                        <h6 className="section_sub_title">Choose similar product from the list</h6>
                    </div>

                    <ProductSlider />
                </div>
            </div>
        </div>
    );
};

export default Shop1;